import React, { useEffect, useState } from 'react';
import { Avatar, Layout, Menu, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './css/sidebar.css'
import {
  AppstoreAddOutlined,
  LogoutOutlined,
  WalletOutlined,
  DownloadOutlined,
  SwitcherOutlined,
  LinkOutlined, FullscreenOutlined,
  CreditCardOutlined, ApiOutlined,
  BankOutlined,
  UserOutlined,
  DollarOutlined,
  SettingOutlined,
  CloseOutlined,
  NotificationOutlined,
  FileJpgOutlined
} from '@ant-design/icons';
import paxitylogosidebar from '../assets/images/paxity-logo-sidebar.png'
import '../common/css/style.css'
import category from '../assets/images/category.png'
import arrowsdoublesenw from '../assets/images/arrows-double-se-nw.png'
import buildingstore from '../assets/images/building-store.png'
import users from '../assets/images/users.png'
import notif from '../assets/images/notification.png'
import rapport from '../assets/images/report-analytics.png'
import setting from '../assets/images/settings.png'
import ValidationDocs from '../modules/admin/validationdocs/pages';

const { Sider } = Layout;

function Sidebar(props) {

  const navigate = useNavigate();
  const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  const role = currentUser?.roles

  const goToHome = () => {
    navigate('/dashboard');
  }
  const goToHomeAdmin = () => {
    navigate('/dashboard-admin');
  }
  const Developer = () => {
    navigate('/business');
  }
  const Solde = () => {
    navigate('/solde');
  }
  const Versements = () => {
    navigate('/demande-reversement');
  }
  const VersementsMasse = () => {
    navigate('/paiement-de-masse');
  }
  const goToPaymentApplications = () => {
    navigate('/compte-versements');
  }
  const Bientot = () => {
    navigate('/bientot');
  }
  const paymentLink = () => {
    navigate('/lien-de-paiement');
  }
  const collectes = () => {
    navigate('/collectes');
  }

  const BusinessManagement = () => {
    navigate('/business-management');
  }
  const MerchentManagement = () => {
    navigate('/marchand');
  }
  const Transactions = () => {
    navigate('/transaction-admin');
  }
  const Paramétres = () => {
    navigate('/parametres/commissions');
  }
   const NotificationsAdmin = () => {
    navigate('/notification-admin');
  }
   const Rapport = () => {
    navigate('/rapports');
  }
   const ValidationDocs = () => {
    navigate('/validations-documents');
  }

  const isMerchant = role && role.includes("MERCHANT");
  const isAdmin = role && role.includes("ADMIN");

  const location = useLocation();
  const pathKeyMap = {
    '/dashboard-admin': '1',
    '/dashboard-admin': '15',
    '/business-menagement': '3',
    '/solde': '2',
    '/demande-reversement': '4',
    '/collectes': '5',
    '/lien-de-paiement': '6',
    '/paiement-de-masse': '7',
    '/bientot': '8',
    '/compte-versements': '9',
    '/marchand': '11',
    '/business-management': '12',
    '/transaction-admin': '13',
    '/parametres/commissions': '14',
    //'/notification-admin': '16', 
    //'/rapports': '17',
    //'/validations-documents':'18'
  };

  // trouve la clé dont le path est inclus dans l’URL actuelle
  // Trouve la clé sélectionnée
  const selectedKey =
    Object.keys(pathKeyMap).find((path) =>
      location.pathname.startsWith(path)
    ) && pathKeyMap[
    Object.keys(pathKeyMap).find((path) =>
      location.pathname.startsWith(path)
    )
    ];
  const [openKeys, setOpenKeys] = useState(['14']);

  // Gérer l’ouverture du SubMenu "Paramètres"
  useEffect(() => {
    if (selectedKey && selectedKey.startsWith('14')) {
      setOpenKeys(['14']); // ouvre "Paramètres" mais sans le sélectionner
    } else {
      setOpenKeys([]);
    }
  }, [selectedKey]);


  return (
    <aside className="sidebar-admin" style={siderStyle}>
      <div className="logo-sidebar-container-admin ">
        <img src={paxitylogosidebar} alt="logo-paxity" style={{ width: '128px', height: '40px' }} />
      </div>
      <Menu
        theme=""
        mode="inline"
        selectedKeys={[selectedKey]}
        openKeys={openKeys}
        className="menu-sidebar-admin"
      >

        {isMerchant && (
          <>
            <Menu.Item key="1" icon={<AppstoreAddOutlined />} onClick={goToHome} style={itemStyle}>
              Dashboard
            </Menu.Item>
            <Menu.Item key="3" icon={<BankOutlined />} onClick={Developer} style={itemStyle}>
              Business
            </Menu.Item>
            <Menu.Item key="2" icon={<WalletOutlined />} onClick={Solde} style={itemStyle}>
              Solde
            </Menu.Item>
            <Menu.Item key="4" icon={<DownloadOutlined />} onClick={Versements} style={itemStyle}>
              Demander un reversement
            </Menu.Item>
            <hr className='hr-sidebar' />
            <Menu.Item key="5" icon={<SwitcherOutlined />} onClick={collectes} style={itemStyle}>
              Collecte
            </Menu.Item>
            <Menu.Item key="6" icon={<LinkOutlined />} onClick={paymentLink} style={itemStyle}>
              Lien de paiement
            </Menu.Item>
            <Menu.Item key="7" icon={<FullscreenOutlined />} onClick={VersementsMasse} style={itemStyle}>
              Paiement de masse
            </Menu.Item>
            <Menu.Item key="8" icon={<CreditCardOutlined />} onClick={Bientot} style={itemStyle}>
              Carte Paxity
            </Menu.Item>
            <hr className='hr-sidebar' />
            <Menu.Item key="9" icon={<ApiOutlined />} onClick={Bientot} style={itemStyle}>
              Intégrer notre API
            </Menu.Item>
          </>
        )}
        {isAdmin && (
          <>
            <hr className="hrSeparator-admin mb-4" />
            <Menu.Item key="15" className="menu-admin" icon={<img src={category} alt="Bientôt" style={{ width: 24, height: 24 }} />} onClick={() => {
              goToHomeAdmin();
              props.onLinkClick?.();
            }}>
              Tableau de bord
            </Menu.Item>
            <Menu.Item key="11" className="menu-admin" icon={<img src={users} alt="Bientôt" style={{ width: 24, height: 24 }} />} onClick={() => {
              MerchentManagement();
              props.onLinkClick?.();
            }}>
              Marchands
            </Menu.Item>
             {/*<Menu.Item key="12" className="menu-admin" icon={<img src={buildingstore} alt="Bientôt" style={{ width: 24, height: 24 }} />} onClick={BusinessManagement} >
              Business
            </Menu.Item>*/}
            
            <Menu.Item key="13" className="menu-admin" icon={<img src={arrowsdoublesenw} alt="Bientôt" style={{ width: 24, height: 24 }} />} onClick={Transactions} >
              Transactions
            </Menu.Item>
            <Menu.Item
              className="menu-admin" 
              key="14"
             icon={<img src={setting} alt="Bientôt" style={{ width: 24, height: 24 }} />}
              onClick={Paramétres}
            >
              Paramètres
            </Menu.Item>
            <Menu.Item
              className="menu-admin" 
              key="16"
              icon={<img src={notif} alt="Bientôt" style={{ width: 24, height: 24 }} />}
              //onClick={NotificationsAdmin}
            >
              Notifications
            </Menu.Item>
          
             <Menu.Item
              className="menu-admin" 
              key="17"
              icon={<img src={rapport} alt="Bientôt" style={{ width: 24, height: 24 }} />}
              //onClick={Rapport}
            >
              Rapports
            </Menu.Item>
             <Menu.Item
              className="menu-admin" 
              key="18"
              icon={<FileJpgOutlined style={{ fontSize: 22}} />}
              //onClick={ValidationDocs}
            >
              Vérification. docs
            </Menu.Item>
          </>
        )}
      </Menu>
      <div className="logout-container">
        <Link to="/logout">
          <Button className='deconnect-button-admin menue-admin ' icon={<LogoutOutlined />}>
            <span>Se déconnecter</span>
          </Button>
        </Link>
      </div>
    </aside>
  );

}
const siderStyle = {
  left:0,
  position: 'fixed',
  top: 0,
  bottom: 0,
  scrollbarWidth: 'thin',
  zIndex: 1000,
};

const itemStyle = {
  fontSize: '1rem',
  padding: '10px',
  marginBottom: '2%'
}
export default Sidebar;
